import React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SearchBar from "../components/searchBar";
import Header from "../components/header";
import "../index.css";
import useChangeBtn from "../hooks/useChangeBtn";
import Recipe from "../components/recipe";
import { Context } from "../Context";

function Detail() {
  const {
    detail,
    setDetail,
    btnText,
    fav,
    setFav,
    setBtnText,
    btnColor,
    setBtnColor,
    disable,
    setDisable,
    changeColor,
    changeTextBtn,
    addToMyList,
  } = useChangeBtn();

  let params = useParams();

  const fetchDetails = async () => {
    try {
      const data = await fetch(
        `https://api.spoonacular.com/recipes/${params.recipeId}/information?apiKey=${process.env.REACT_APP_API_KEY}`
      );
      const detailData = await data.json();
      setDetail(detailData);
      console.log(detailData);
      console.log(detailData.extendedIngredients);
    } catch (err) {
      console.log(err);
      alert(err);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, [params.detail]);

  return (
    <div>
      <Header />
      <div className="detailWrapper">
        <h1 className="text-center font-bold text-lg "> RECEIPE </h1>
        <SearchBar />
        <Context.Provider
          value={{
            detail,
            changeTextBtn,
            btnText,
            btnColor,
            disable,
            addToMyList,
            changeColor,
          }}
        >
          <Recipe detail={detail} key={detail.id} page="detail" />
        </Context.Provider>
      </div>
    </div>
  );
}
export default Detail;
